/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/marketingManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '自营-营销管理',
      icon: 'component',
    },
    children: [
      {
        path: '/marketingManage/crowdManage',
        component: () => import('@/myviews/shoppMall/marketingManage/crowdManage/crowdManageList.vue'),
        alwaysShow: false,
        name: 'crowdManage',
        meta: {
          title: '人群管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/marketingManage/crowdUserManage',
        component: () => import('@/myviews/shoppMall/marketingManage/crowdManage/crowdUserManageList.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'crowdUserManage',
        meta: {
          title: '用户管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/marketingManage/crowdtags',
        component: () => import('@/myviews/shoppMall/marketingManage/crowdtags/crowdtagsList.vue'),
        name: 'crowdtags',
        meta: {
          alwaysShow: false,
          title: '标签管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/marketingManage/smspush',
        component: () => import('@/myviews/shoppMall/marketingManage/smspush/smspushList.vue'),
        alwaysShow: false,
        name: 'smspush',
        meta: {
          title: '短信推送',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/marketingManage/messageManage',
        component: () => import('@/myviews/shoppMall/marketingManage/messageManage/messageManageList.vue'),
        alwaysShow: false,
        hidden: false,
        name: 'messageManage',
        meta: {
          title: '消息推送',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/marketingManage/shortname',
        component: () => import('@/myviews/shoppMall/marketingManage/shortname/shortnameList.vue'),
        name: 'shortname',
        meta: {
          alwaysShow: false,
          title: '商品短名管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/marketingManage/blacklist',
        component: () => import('@/myviews/shoppMall/marketingManage/blacklist/blacklistList.vue'),
        alwaysShow: false,
        name: 'blacklist',
        meta: {
          title: '黑名单',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/shoppMall/marketingManage.js